// Generated by ReScript, PLEASE EDIT WITH CARE

import * as RR from "common/src/RR.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Modal0 from "../common/Modal0.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as TcUtils from "../team-comps/TcUtils.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Tc2Summary from "./Tc2Summary.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Tc2Expanded from "./Tc2Expanded.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import CircularProgress from "@mui/material/CircularProgress";

function Tc2List$Cluster(Props) {
  var globalCount = Props.globalCount;
  var onExpand = Props.onExpand;
  var group = Props.group;
  var onHover = Props.onHover;
  var t = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return false;
      });
  var setExpanded = match[1];
  var expanded = match[0];
  var subcomps = React.useMemo((function () {
          if (group.children.length > 1) {
            return [
                    expanded,
                    setExpanded
                  ];
          }
          
        }), [
        group,
        expanded
      ]);
  var tmp = {
    group: group.full,
    globalCount: globalCount,
    onExpand: onExpand,
    onHover: onHover
  };
  if (subcomps !== undefined) {
    tmp.subcomps = Caml_option.valFromOption(subcomps);
  }
  return React.createElement("div", {
              className: expanded ? "py-5" : ""
            }, React.createElement(Tc2Summary.make, tmp), group.children.length > 1 && expanded ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: "mt-3 mb-3 w-full flex items-center"
                      }, React.createElement("hr", {
                            className: "flex-1"
                          }), React.createElement("div", {
                            className: "px-3 font-montserrat font-medium text-lg leading-none text-white1"
                          }, t("Subcomps")), React.createElement("hr", {
                            className: "flex-1"
                          })), Belt_Array.mapWithIndex(Belt_SortArray.stableSortBy(group.children, (function (g1, g2) {
                              return Caml.caml_int_compare(g2.count, g1.count);
                            })), (function (idx, group) {
                          return React.createElement(Tc2Summary.make, {
                                      group: group,
                                      globalCount: globalCount,
                                      onExpand: onExpand,
                                      onHover: onHover,
                                      key: String(idx)
                                    });
                        }))) : null);
}

var Cluster = {
  make: Tc2List$Cluster
};

function Tc2List(Props) {
  var groups = Props.groups;
  var globalCount = Props.globalCount;
  var filters = Props.filters;
  var fullDataLoaded = Props.fullDataLoaded;
  var expandSubcomps = Props.expandSubcomps;
  var hideLowPlayrates = Props.hideLowPlayrates;
  var sortOrder = Props.sortOrder;
  var showAugComps = Props.showAugComps;
  var set = TftSet.use(undefined);
  var match = React.useState(function () {
        
      });
  var setExpandedGroup = match[1];
  var expandedGroup = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setOpened = match$1[1];
  var opened = match$1[0];
  var match$2 = React.useState(function () {
        return 8;
      });
  var setRenderCount = match$2[1];
  var renderCount = match$2[0];
  var renderCountRef = React.useRef(renderCount);
  RR.useIsoLayoutEffect1((function (param) {
          renderCountRef.current = renderCount;
          
        }), [renderCount]);
  React.useEffect((function () {
          Curry._1(setExpandedGroup, (function (g) {
                  if (g !== undefined) {
                    return Caml_option.some(Caml_option.valFromOption(g));
                  } else {
                    return Belt_Option.map(Belt_Array.get(groups, 0), (function (g) {
                                  return g.full;
                                }));
                  }
                }));
          
        }), []);
  var onExpand = React.useCallback((function (g) {
          Curry._1(setExpandedGroup, (function (param) {
                  return Caml_option.some(g);
                }));
          return Curry._1(setOpened, (function (param) {
                        return true;
                      }));
        }), []);
  var onHover = React.useCallback((function (g) {
          return Curry._1(setExpandedGroup, (function (param) {
                        return Caml_option.some(g);
                      }));
        }), []);
  var throttle = React.useRef(false);
  React.useEffect((function () {
          var cb = function (param) {
            var sh = document.documentElement.scrollHeight;
            var scrollY = window.scrollY | 0;
            var ih = window.innerHeight;
            if (((sh - (scrollY + ih | 0) | 0) < 350 || (scrollY + ih | 0) > (500 + Math.imul(renderCountRef.current, 150) | 0)) && !throttle.current) {
              Curry._1(setRenderCount, (function (re) {
                      return Caml.caml_int_min(re + 4 | 0, 100);
                    }));
              throttle.current = true;
              setTimeout((function (param) {
                      throttle.current = false;
                      return cb(undefined);
                    }), 350);
              return ;
            }
            
          };
          window.addEventListener("scroll", cb, {
                passive: true,
                capture: false,
                once: false
              });
          cb(undefined);
          return (function (param) {
                    window.removeEventListener("resize", cb);
                    
                  });
        }), []);
  var onCloseModal = React.useCallback((function (param) {
          return Curry._1(setOpened, (function (param) {
                        return false;
                      }));
        }), []);
  var tmp;
  if (expandSubcomps) {
    var groups$1 = Belt_Array.concatMany(Belt_Array.map(groups, (function (g) {
                if (g.children.length !== 0) {
                  return g.children;
                } else {
                  return [g.full];
                }
              })));
    var groups$2 = Belt_SortArray.stableSortBy(Belt_Array.keep(Belt_Array.keep(groups$1, (function (group) {
                    return Belt_Array.some(group.nonSpatComps, (function (comp) {
                                  return TcUtils.compFilterMatch(comp, filters, set);
                                }));
                  })), (function (g) {
                if (hideLowPlayrates) {
                  return Global.f(g.count) / Global.f(globalCount) >= 0.03 / 8;
                } else {
                  return true;
                }
              })), (function (g1, g2) {
            switch (sortOrder) {
              case /* Popularity */0 :
                  return -Caml.caml_int_compare(g1.count, g2.count) | 0;
              case /* Place */1 :
                  return Caml.caml_float_compare(g1.place, g2.place);
              case /* Top4 */2 :
                  return -Caml.caml_float_compare(Global.f(g1.top4) / Global.f(g1.count), Global.f(g2.top4) / Global.f(g2.count)) | 0;
              case /* Win */3 :
                  return -Caml.caml_float_compare(Global.f(g1.win) / Global.f(g1.count), Global.f(g2.win) / Global.f(g2.count)) | 0;
              
            }
          }));
    tmp = React.createElement(React.Fragment, undefined, Belt_Array.mapWithIndex(groups$2, (function (idx, group) {
                return React.createElement("div", {
                            key: String(idx),
                            className: idx % 2 === 0 ? "bg-bg2" : ""
                          }, React.createElement(Tc2Summary.make, {
                                group: group,
                                globalCount: globalCount,
                                onExpand: onExpand,
                                onHover: onHover
                              }));
              })), renderCount < groups$2.length || !fullDataLoaded ? React.createElement("div", {
                className: "w-full flex justify-center py-8"
              }, React.createElement(CircularProgress, {
                    size: 64
                  })) : null);
  } else {
    var groups$3 = Belt_SortArray.stableSortBy(Belt_Array.keep(Belt_Array.keep(groups, (function (group) {
                    if (hideLowPlayrates) {
                      return Global.f(group.full.count) / Global.f(globalCount) >= 0.03 / 8;
                    } else {
                      return true;
                    }
                  })), (function (group) {
                if (showAugComps) {
                  return true;
                } else {
                  return Belt_Option.isNone(TcUtils.getCoreAug(group.full));
                }
              })), (function (g1, g2) {
            switch (sortOrder) {
              case /* Popularity */0 :
                  return -Caml.caml_int_compare(g1.full.count, g2.full.count) | 0;
              case /* Place */1 :
                  return Caml.caml_float_compare(g1.full.place, g2.full.place);
              case /* Top4 */2 :
                  return -Caml.caml_float_compare(Global.f(g1.full.top4) / Global.f(g1.full.count), Global.f(g2.full.top4) / Global.f(g2.full.count)) | 0;
              case /* Win */3 :
                  return -Caml.caml_float_compare(Global.f(g1.full.win) / Global.f(g1.full.count), Global.f(g2.full.win) / Global.f(g2.full.count)) | 0;
              
            }
          }));
    var groups$4 = Belt_Array.keepMap(groups$3, (function (group) {
            if (Belt_Array.some(group.full.nonSpatComps, (function (comp) {
                      return TcUtils.compFilterMatch(comp, filters, set);
                    }))) {
              return group;
            }
            var subgroup = group.children.find(function (group) {
                  return Belt_Array.some(group.nonSpatComps, (function (comp) {
                                return TcUtils.compFilterMatch(comp, filters, set);
                              }));
                });
            return Belt_Option.map(subgroup === undefined ? undefined : Caml_option.some(subgroup), (function (sg) {
                          return {
                                  full: sg,
                                  children: []
                                };
                        }));
          }));
    tmp = React.createElement(React.Fragment, undefined, Belt_Array.mapWithIndex(groups$4, (function (idx, group) {
                if (idx < renderCount) {
                  return React.createElement("div", {
                              key: String(idx),
                              className: idx % 2 === 0 ? "bg-bg2" : ""
                            }, React.createElement(Tc2List$Cluster, {
                                  filters: filters,
                                  globalCount: globalCount,
                                  onExpand: onExpand,
                                  group: group,
                                  onHover: onHover
                                }));
                } else {
                  return null;
                }
              })), renderCount < groups$4.length || !fullDataLoaded ? React.createElement("div", {
                className: "w-full flex justify-center py-8"
              }, React.createElement(CircularProgress, {
                    size: 64
                  })) : null);
  }
  return React.createElement(React.Fragment, undefined, React.createElement(ContentSection.make, {
                  className: "mt-6",
                  children: React.createElement("div", {
                        className: "w-[375px] sm:w-[540px] md:w-full grid"
                      }, tmp),
                  noPadding: true
                }), React.createElement(Modal0.make, {
                  opened: opened,
                  onClose: onCloseModal,
                  children: expandedGroup !== undefined ? React.createElement(Tc2Expanded.make, {
                          filters: filters,
                          group: Caml_option.valFromOption(expandedGroup),
                          globalCount: globalCount,
                          onClose: onCloseModal,
                          samplingRatio: 1,
                          opened: opened
                        }) : null,
                  modalClass: "w-[680px] p-4 sm:p-5"
                }));
}

var make = Tc2List;

export {
  Cluster ,
  make ,
  
}
/* RR Not a pure module */
